import React, { PureComponent } from "react";
import { getRouter, getRouterAPP } from '../router';
import GlobalHeader from 'components/GlobalHeader'
import GlobalFooter from 'components/GlobalFooter'

import "./index.scss";
var nav = [
  {
    name: "首页",
    url: "/entrance/home",
  },
  {
    name: "就业招聘",
    url: "/entrance/employment",
  },
  {
    name: "教育培训",
    url: "/entrance/education"
  },
  {
    name: "创业帮扶",
    url: "/entrance/entrepreneurship"
  },
  {
    name: "政策汇总",
    url: "/entrance/policy"
  },
  {
    name: "个人中心",
    url: "/entrance/personal"
  }
];


export default class Index extends PureComponent {

  render() {
    let isMobile = false;
    if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
      isMobile = true
    }
    else {
      isMobile = false
    }
    return (
      isMobile == false ?
        <div>
          <GlobalHeader nav={nav} history={this.props.history} />
          {getRouter()}
          <GlobalFooter />
        </div> :
        <div>
          {getRouterAPP()}
        </div>

    );
  }
}
